import { FC } from 'react';
import Drawer from '@cld/drawer';
import { useSideMenu } from './SideMenu.context';
import { SideMenuProps } from './SideMenu.types';
import { SideMenuCommon } from './SideMenu';

export const SideMenuMobile: FC<SideMenuProps> = ({ header, secondaryContent, footer, children }) => {
  const { isSideMenuMobileOpen, toggleOpenState } = useSideMenu();

  return (
    <Drawer open={isSideMenuMobileOpen} onBackdropClick={toggleOpenState} position="left">
      <SideMenuCommon header={header} secondaryContent={secondaryContent} footer={footer} children={children} />
    </Drawer>
  );
};
